import { createClientAuth } from '@whoop/auth-client';
import { env } from 'env';

const auth = createClientAuth({
  env: env.NEXT_PUBLIC_ENV,
  segmentKey: env.NEXT_PUBLIC_SEGMENT_API_KEY,
});

export default auth;
